import ContactForm from "../contact/ContactForm";
import { socialLinks } from "./landingContent";

const socialIconPaths = {
  Discord: (
    <path d="M20.3 4.4A17.2 17.2 0 0016.1 3l-.2.4c1.5.4 2.2 1 2.2 1s-2.2-1.2-5.1-1.2c-2.9 0-5.1 1.2-5.1 1.2s.8-.7 2.3-1L10 3a17.2 17.2 0 00-4.2 1.4C3.1 8.4 2.4 12.2 2.7 16c1.8 2 4.5 2 4.5 2l.6-.8c-1.1-.3-1.8-.9-1.8-.9s.2.1.5.3c2 .9 4.2 1.2 6.4 1.1a12.8 12.8 0 005.1-1.4s-.7.6-1.9.9l.6.8s2.7 0 4.5-2c.4-4.4-.7-8.2-3-11.6zM8.7 14.4c-.8 0-1.4-.7-1.4-1.6s.6-1.6 1.4-1.6 1.5.7 1.4 1.6c0 .9-.6 1.6-1.4 1.6zm5.7 0c-.8 0-1.4-.7-1.4-1.6s.6-1.6 1.4-1.6 1.4.7 1.4 1.6-.6 1.6-1.4 1.6z" />
  ),
  X: (
    <path d="M14.6 10.2L22.7 1h-1.9l-7 7.9L8.2 1H1.7l8.5 12.1L1.7 23h1.9l7.5-8.6 6.1 8.6h6.5l-9.1-12.8zm-2.7 3.1l-.9-1.2L4.2 2.4h3.3l5.5 7.8.9 1.2 7.2 10.2h-3.3l-5.9-8.3z" />
  ),
  Instagram: (
    <>
      <rect x="2" y="2" width="20" height="20" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
    </>
  ),
};

const SocialIcon = ({ label }) => {
  if (label === "Discord") {
    return (
      <i
        className="fab fa-discord bl-connect-social__font-icon"
        aria-hidden="true"
      />
    );
  }

  if (label === "Instagram") {
    return (
      <svg
        className="bl-connect-social__icon bl-connect-social__icon--instagram"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        aria-hidden="true"
      >
        {socialIconPaths[label]}
      </svg>
    );
  }

  return (
    <svg
      className="bl-connect-social__icon"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      {socialIconPaths[label]}
    </svg>
  );
};

const renderSocialLabel = (label) => {
  if (label === "X") {
    return null;
  }

  return label;
};

const LandingConnectSection = () => (
  <section className="bl-connect" id="connect">
    <div className="bl-connect__shell">
      <div className="bl-connect__copy">
        <div className="bl-connect__eyebrow">Connect with us</div>
        <h2>Get in touch.</h2>
        <p>
          Questions, feedback, or just want to know more? Reach out directly or
          find us on social.
        </p>

        <a className="bl-connect-email" href="mailto:support@bodylytix.ai">
          <span className="bl-connect-email__icon">@</span>
          <span>
            <span className="bl-connect-email__label">Email us</span>
            <span className="bl-connect-email__value">
              support@bodylytix.ai
            </span>
          </span>
        </a>

        <div className="bl-connect-socials">
          {socialLinks.map((link) => (
            <a
              className="bl-connect-social"
              href={link.href}
              target="_blank"
              rel="noreferrer"
              aria-label={link.label}
              key={link.label}
            >
              <SocialIcon label={link.label} />
              {renderSocialLabel(link.label)}
            </a>
          ))}
        </div>
      </div>

      <ContactForm variant="landing" title="Send us a message" />
    </div>
  </section>
);

export default LandingConnectSection;
